// THIS FILE IS AUTO GENERATED
var GenIcon = require('../lib').GenIcon
module.exports.IconArrowThickLeft = function IconArrowThickLeft (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"title","attr":{}},{"tag":"polygon","attr":{"id":"fill-color","points":"15.097166 4 17 5.88 10.8191633 12 17 18.12 15.097166 20 7 12"}}]})(props);
};
